import React, { useEffect, useState } from 'react';
import { getNewUserList, getSiteMetrics } from '../../api/adminPanel';
import './Admin_Users.css';
import Group108 from "../images/Group 108.png";
import MostFollowedUsersAdmin from './MostFollowedUsers_Admin';
import TopActiveUsersAdmin from './TopActiveUsers_Admin';
import NewUserListAdmin from './NewUserList_Admin';
import MobileAdminSideNav from '../MobileAdminSideNav/MobileAdminSideNav';
import AdminSideNav from './AdminSideNav/AdminSideNav';
import DelProfPost from './DelProfPost';
import MentorApproval from './MentorApproval';
import DeadUserList from './DeadUserList';
import TopPosts from './TopPosts';

const Admin_Users = () => {
    const [siteData, setSiteData] = useState({});
    const [NewUsrList, setNewUsrList] = useState([]);

    useEffect(() => {
  const getData = async () => {
    try {
      const siteRes = await getSiteMetrics();
      setSiteData(siteRes?.data?.result ?? {});

      const newUserRes = await getNewUserList();
      setNewUsrList(newUserRes?.data?.result ?? []);
    } catch (err) {
      console.error("Admin Users fetch failed:", err);
      setSiteData({});
      setNewUsrList([]);
    }
  };

  getData();
}, []);

    return (
        <>
        <MobileAdminSideNav/>
        {/* {isMobile ? <MobileAdminSideNav/> : <AdminSideNav />} */}
        <AdminSideNav />
        <div className="container_user" style={{fontWeight: 'bold' }}>
            Users Overview
            <div className="boxes1" style={{fontWeight: 'bold' }}>
                <div>
                    Total Users
                </div>
                <div className="inside-box">
                    <div className="data">
                    {siteData.users}
                    </div>
                    <img src={Group108} alt="Total Users"/>
                </div>
            </div>
            <MentorApproval />
            <div className="review">
                <div className="top_of_reviews" style={{fontWeight: 'bold' }}>
                    <div>
                        Daily New Users
                    </div>
                    <div>
                        <button className="viewall">
                            View All 
                        </button>
                    </div>
                </div>
                <NewUserListAdmin users={NewUsrList} />
         
            </div>
            <div className="review">
                <div className="top_of_reviews">
                    <div>
                        Most Active Users
                    </div>
                    <div>
                        <button className="viewall">
                            View All 
                        </button>
                    </div>
                </div>
                <TopActiveUsersAdmin/>
                
            </div>
            <div className="review">
                <div className="top_of_reviews">
                    <div>
                        Most Followed Users
                    </div>
                    <div>
                        <button className="viewall">
                            View All 
                        </button>
                    </div>
                </div>
                <MostFollowedUsersAdmin/>
                
            </div>
            <DelProfPost />
            <DeadUserList />
            <TopPosts />
        </div>
        </>

    );
};
export default Admin_Users ;